import { t } from '../i18n';
import '../styles/uiChrome.css';

export interface UIChromeListeners {
  onStartStopSimulation: () => Promise<void>;
  onTogglePause: () => void;
  onEndMission: () => void;
}

export interface UIChromeState {
  generation: number;
  isRunning: boolean;
  isPaused: boolean;
}

/**
 * UI Chrome (Top Bar) Component
 */
export class UIChrome {
  private container: HTMLElement;
  private listeners: UIChromeListeners;
  private state: UIChromeState;

  constructor(container: HTMLElement, state: UIChromeState, listeners: UIChromeListeners) {
    this.container = container;
    this.listeners = listeners;
    this.state = state;
    this.render();
  }

  /**
   * Update component state and re-render
   */
  public update(newState: Partial<UIChromeState>): void {
    this.state = { ...this.state, ...newState };
    this.render();
  }

  private render(): void {
    this.container.innerHTML = `
      <div class="chrome-section">
        <div class="generation-display">
          <span class="generation-label">${t('generation')}</span>
          <span class="generation-value">${this.state.generation}</span>
        </div>
        <div class="status-indicator">
          <div class="status-dot ${this.state.isRunning ? (this.state.isPaused ? 'paused' : 'running') : ''}"></div>
        </div>
      </div>

      <div class="chrome-section">
        <button class="chrome-btn" id="stop-simulation-btn">
          ${this.state.isRunning ? t('stop') : t('run')}
        </button>
        ${this.state.isRunning ? `
          <button class="chrome-btn" id="toggle-pause-btn">
            ${this.state.isPaused ? t('resume') : t('pause')}
          </button>
        ` : ''}
      </div>

      <div class="chrome-section">
        <button class="chrome-btn danger" id="end-mission-btn">
          ${t('endMission')}
        </button>
      </div>
    `;

    this.attachListeners();
  }

  private attachListeners(): void {
    this.container.querySelector('#stop-simulation-btn')?.addEventListener('click', async (): Promise<void> => {
      await this.listeners.onStartStopSimulation();
    });

    this.container.querySelector('#toggle-pause-btn')?.addEventListener('click', () => {
      this.listeners.onTogglePause();
    });

    this.container.querySelector('#end-mission-btn')?.addEventListener('click', () => {
      if (confirm(t('endMissionConfirm'))) {
        this.listeners.onEndMission();
      }
    });
  }
}
